import Joi from "joi";

export const defaultValidationOptions: Joi.AsyncValidationOptions = {
  abortEarly: false,
  presence:   "required",
};
